import { Component, Output, EventEmitter } from '@angular/core'
import { environment } from '@environments/environment'

@Component({
  selector: 'app-business-new-profile',
  templateUrl: './business-new-profile.component.html',
  styleUrls: ['./business-new-profile.component.scss']
})
export class BusinessNewProfileComponent {

  public environment = environment

  @Output() createNewProfile = new EventEmitter<boolean>()
  @Output() createNewProfileCarpenterPlus = new EventEmitter<boolean>()
  @Output() createNewProfileOther = new EventEmitter<boolean>()

  public cards = [
    {
      caption: 'Handwerker-Paket',
      subcaption: 'Kostenlos',
      description: 'Für Handwerksbetriebe und Dienstleister wie Planer, Statiker, Maschinenhändler',
      buttontext: 'Unternehmensprofil erstellen',
      bullets: [
        'Unternehmen professionell präsentieren',
        'Blog-Beiträge erstellen',
        'Produkte im Marktplatz verkaufen',
        'Jobbörse: Mitarbeiter gewinnen',
        'Bonuspunkte sammeln',
      ],
      function: () => this.CARPENTER(),
      'class': 'first-column'
    },
    {
      caption: 'Partner Basis-Paket',
      subcaption: 'Upgrade / Jahresabo',
      description: 'Für Hersteller, größere Dienstleister, Organisationen, Handwerksbetriebe',
      buttontext: 'Unternehmensprofil erstellen und Anfrage senden',
      bullets: [
        'Unternehmen professionell präsentieren',
        'Blog-Beiträge erstellen',
        'Produkte im Marktplatz verkaufen',
        'Jobbörse: Mitarbeiter gewinnen',
        'Bonuspunkte sammeln',
        'Logo-Platzierung als Partner',
        'Zusatzleistungen buchbar (Newsletter, Slider-Platzierung)',
      ],
      function: () => this.CARPENTER_PLUS(),
      'class': 'second-column'
    },
    {
      caption: 'Partner Premium-Paket',
      subcaption: 'Upgrade / Jahresabo',
      description: 'Für Hersteller, größere Dienstleister, Organisationen, Handwerksbetriebe',
      buttontext: 'Unternehmensprofil erstellen und Anfrage senden',
      bullets: [
        'Unternehmen professionell präsentieren',
        'Blog-Beiträge erstellen',
        'Produkte im Marktplatz verkaufen',
        'Jobbörse: Mitarbeiter gewinnen',
        'Bonuspunkte sammeln',
        'Logo-Platzierung als Partner',
        'Zusatzleistungen buchbar (Newsletter, Slider-Platzierung)',
        'Social Media Reichweite (Beiträge beworben)',
        'Persönliche Beratung',
      ],
      function: () => this.OTHER(),
      'class': 'third-column'
    }
  ]

  constructor() { }

  public CARPENTER() {
    this.createNewProfile.emit(true)
  }

  public CARPENTER_PLUS() {
    this.createNewProfileCarpenterPlus.emit(true)
  }

  public OTHER() {
    this.createNewProfileOther.emit(true)
  }

}
